import { cva } from 'class-variance-authority';

/**
 * Switch component variant styles using CVA for consistent styling.
 */
export const switchVariants = cva(
  [
    // Base container styles
    'relative flex items-center justify-center',
    'border-2 border-solid border-[var(--color-brand-primary)]',
    'rounded-full',
    'box-border',
  ],
  {
    variants: {
      size: {
        xs: 'h-8 p-[3px]',
        small: 'h-10 p-[3px]',
        default: 'h-14 p-[3px]',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);
